const Assets = {
  formBuilderUrl: process.env.PREACT_APP_FORM_BUILDER_URL,
}

export default Assets
